import React, {useState} from 'react';
import {Button, Dialog, Classes, Intent, TextArea} from '@blueprintjs/core';
import {Label, TextField} from 'worksource-ui';
import {useMutation} from '@apollo/react-hooks';
import {gql} from 'apollo-boost';
import mixpanel from 'mixpanel-browser';

import {useUIActions} from 'utils/ui-context';
import {showSuccess, showWSErrors, showGQLError} from 'utils/toaster';
import {useCurrentUser} from '../utils/auth';

const SEND_REQUEST = gql`
  mutation SendFeatureInformationRequest($clientId: ID!, $feature: String!, $notes: String) {
    requestFeatureInformation(clientId: $clientId, feature: $feature, notes: $notes) {
      success,
      errors {
        title,
        message,
      },
    }
  }
`;

const AdditionalFeatureDialog = (props) => {
  ////
  // Hooks
  //
  const {clearDialog} = useUIActions();
  const [notes, setNotes] = useState('');
  const currentUser = useCurrentUser();
  const [sendRequest, {loading}] = useMutation(SEND_REQUEST, {
    onCompleted: ({requestFeatureInformation: {errors}}) => {
      if (errors.length > 0) {
        showWSErrors({errors});
      } else {
        showSuccess({message: 'Information request sent! We\'ll be in touch shortly.'});
        clearDialog();
      }
    },
    onError: error => showGQLError({error}),
  });

  ////
  // Events
  //
  const send = () => {
    mixpanel.track('Send feature information request', {feature: props.feature});
    sendRequest({variables: {
      clientId: props.clientId,
      feature: props.feature,
      notes,
    }});
  };

  ////
  // Render
  //
  return (
    <Dialog
      isOpen={props.isOpen}
      onClose={clearDialog}
      icon="envelope"
      title="Learn more"
    >
      <div className={Classes.DIALOG_BODY}>
        <p>
          Let us know if you have any additional notes you'd like to send along
          with your request for information. Our sales team will reach out
          shortly with next steps.
        </p>
        <Label text="Email address">
          <TextField
            fluid
            disabled
            value={currentUser.email}
          />
        </Label>
        <Label text="Additional notes">
          <TextArea
            className="bp3-fill"
            onChange={e => setNotes(e.target.value)}
            placeholder="Additional notes (optional)"
            value={notes}
          />
        </Label>
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button disabled={loading} text="Cancel" onClick={clearDialog} />
          <Button
            disabled={loading}
            loading={loading}
            intent={Intent.PRIMARY}
            text="Send"
            onClick={send}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default AdditionalFeatureDialog;
